export default "__VITE_ASSET__W8U49zaH__"